import { CarProfileIcon, PlusIcon } from '@phosphor-icons/react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';

/** Um passo AINDA NÃO reservado que o host oferece entre os trechos (#6314: a corrida entre o
 *  pouso e o hotel). O pacote só desenha: os textos e a ação vêm prontos do host. */
export interface ItinerarySlot {
  key: string;
  /** O dia do passo, `YYYY-MM-DD` no relógio local do lugar (a régua de `dayKey`). */
  day: string;
  /** `HH:mm`, a hora que ordena o passo entre os do dia. */
  time: string;
  /** O rótulo fantasma sobre o slot, «Corrida · 14:40». */
  label: string;
  title: string;
  detail: string;
  actionLabel: string;
  onAction: () => void;
  /** A arte do serviço: o slot vira a sugestão tracejada com «+ Agendar» (#6797, H5.0d). */
  art?: string;
}

/** O slot: rótulo e glifo em muted (o passo não emitido é fantasma), o fundo neutro de apoio
 *  sem borda nem sombra — só o serviço emitido tem elevação — e o slot inteiro é a ação. */
export function SlotRow({ slot, linked }: Readonly<{ slot: ItinerarySlot; linked: boolean }>) {
  return (
    <div className={linked ? 'tp-stop tp-stop--linked tp-stop--slot' : 'tp-stop tp-stop--slot'}>
      <span className="tp-stop__rail" aria-hidden="true">
        <CarProfileIcon size={16} weight="bold" />
      </span>
      <span className="tp-stop__step">{slot.label}</span>
      <div className={slot.art ? 'tp-slot tp-slot--art' : 'tp-slot'}>
        <button
          type="button"
          className="tp-slot__hit"
          aria-label={`${slot.actionLabel}: ${slot.title}`}
          onClick={slot.onAction}
        />
        {slot.art ? <img className="tp-slot__art" src={slot.art} alt="" /> : null}
        <span className="tp-slot__text">
          <span className="tp-slot__ttl">{slot.title}</span>
          <span className="tp-slot__detail">{slot.detail}</span>
        </span>
        <Button
          type="button"
          variant={slot.art ? 'ghost' : 'outline'}
          className="tp-slot__action"
          tabIndex={-1}
          aria-hidden
          onClick={slot.onAction}
        >
          {slot.art ? <PlusIcon weight="bold" /> : null}
          {slot.actionLabel}
        </Button>
      </div>
    </div>
  );
}
